import { useState } from "react";
import { LoadingSpinner } from "../../components/BaseComponents";
import ConfirmationModal from "../../components/BaseComponents/ConfirmationModal";
import PageHeadings from "../../components/BaseComponents/PageHeadings/PageHeadings";
import useApi from "../../hooks/useApi";
import { getCSRFToken } from "../../lib/utils";

type DeletePortfolioEntryModalProps = {
    onClose: () => void,
    onDeleted: () => void
    isOpen?: boolean,
    portfolioId: string,
    portfolioName: string,
    companyId: string,
    companyName: string,
};

function DeletePortfolioEntryModal({onClose, onDeleted, isOpen, portfolioId, portfolioName, companyId, companyName}: DeletePortfolioEntryModalProps) {
    const api = useApi();
    const [loading, setLoading] = useState(false);

    const deletePortfolio = async () => {
        setLoading(true);
        await api.post(`/portfolios/${portfolioId}/remove/${companyId}`, {
            _csrf: await getCSRFToken(),
        })
        setLoading(false);
        onDeleted();
    }


    return (
        <ConfirmationModal open={!!isOpen} onCancel={onClose} onConfirm={deletePortfolio}>
            <div className="flex flex-col">
                <PageHeadings title={`Remove from ${portfolioName}?`} />
                { loading ? (
                    <LoadingSpinner />
                ) : (
                    <p className="text-white mt-8">
                        Remove {companyName} from this portfolio?
                    </p>
                )}
            </div>
        </ConfirmationModal>
    )
}

export default DeletePortfolioEntryModal;
